module.exports = __webpack_public_path__ + "static/media/support.26c83923.svg";